import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type VideoProgressResponse = object;

export const AddVideoProgress = async (videoId: string): Promise<VideoProgressResponse> => {
  try {
    const response = await axios.patch(`/video/progress/${videoId}`);
    return { data: response.data };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      throw apiError;
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      throw fallbackError;
    }
  }
};
